import { createPicker } from './createPicker.js';

const DatePicker = createPicker();

export { DatePicker };
//# sourceMappingURL=DatePicker.js.map
